import { type Ref, onMounted, onUnmounted } from "vue";
import { type Router } from "vue-router";

import { i18n } from "@/mixins/localization";

const { t } = i18n.global;

// A single page can contain multiple usePreventUnload() calls (for each editor). We have to
// collect all of them and prevent reload if any of them is preventing a reload. And we can't
// simply use onBeforeRouteUpdate because that would trigger the confirm dialog multiple times
// (for each editing editor).
const conditions: Set<Ref<boolean>> = new Set();

function shouldPrevent(): boolean {
    return Array.from(conditions).some((ref) => ref.value);
}

export function usePreventUnload(condition: Ref<boolean>): void {
    onMounted(() => {
        conditions.add(condition);
    });
    onUnmounted(() => {
        conditions.delete(condition);
    });
}

export function installPreventUnload(router: Router): void {
    router.beforeEach((to, from) => {
        if (to.path === from.path || !shouldPrevent()) {
            return true;
        }
        return confirm(t("unsavedChanges"));
    });

    window.addEventListener("beforeunload", (ev: BeforeUnloadEvent) => {
        if (shouldPrevent()) {
            ev.preventDefault();
        }
    });
}
